import React, { Component } from 'react'
import { Card,Button, Icon } from 'semantic-ui-react'

class NewsListItem extends Component {
  render() {
    return (
        <div className="notice-list-item">
            <h3>{this.props.headline}</h3>
            <b>{this.props.postedon}</b>
            <p>{this.props.description}</p>
            <div>
              <Button primary type="button" onClick={this.props.editClick}>Edit</Button>     &nbsp;          
              <Button color='red' type="button" onClick={this.props.onDeleteClick}>Delete</Button>              
            </div>
        </div>
    )
  }
}

export default NewsListItem;



// WEBPACK FOOTER //
// ./src/HomeComponents/News/NewsListItem.js